import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { db, functions } from "./firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";
import Navbar from "./Navbar";

const C = {
  bg:"#0a0a0f", surface:"rgba(255,255,255,0.04)", sh:"rgba(255,255,255,0.07)",
  border:"rgba(255,255,255,0.08)", text:"#f5f5f7",
  sec:"rgba(245,245,247,0.55)", ter:"rgba(245,245,247,0.30)",
  accent:"#0a84ff", green:"#30d158", red:"#ff453a", orange:"#ff9f0a",
};
const F = "-apple-system,'SF Pro Display','Helvetica Neue',sans-serif";

const inp = { width:"100%", padding:"0.65rem 0.85rem", background:"rgba(255,255,255,0.05)", border:"1px solid rgba(255,255,255,0.09)", borderRadius:10, color:C.text, fontSize:"0.85rem", boxSizing:"border-box", outline:"none", fontFamily:F, marginBottom:"0.85rem" };

const Btn = ({ children, onClick, color=C.accent, style={} }) => (
  <button onClick={onClick} style={{ padding:"0.5rem 0.9rem", background:color+"18", border:`1px solid ${color}30`, borderRadius:9, color:C.text, fontSize:"0.75rem", fontWeight:600, cursor:"pointer", fontFamily:F, transition:"background 150ms ease", ...style }}
    onMouseEnter={e=>e.currentTarget.style.background=color+"30"}
    onMouseLeave={e=>e.currentTarget.style.background=color+"18"}
  >{children}</button>
);

const ROLE_COLORS = { admin:"#bf5af2", gestore:"#0a84ff", cassa:"#ff9f0a" };

export default function GestioneUtenti() {
  const [utenti, setUtenti] = useState([]);
  const [selezionato, setSelezionato] = useState(null);
  const [form, setForm] = useState({ nome:"", email:"", ruolo:"", localeTag:"" });
  const [messaggio, setMessaggio] = useState("");
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const carica = async () => {
    const snap = await getDocs(collection(db, "utenti"));
    setUtenti(snap.docs.map(d => ({ id:d.id, ...d.data() })));
  };

  useEffect(() => { carica(); }, []);

  const apriModifica = (u) => {
    setSelezionato(u);
    setForm({ nome:u.nome||"", email:u.email||"", ruolo:u.ruolo||"", localeTag:u.localeTag||"" });
    setMessaggio("");
  };

  const salva = async () => {
    if (!selezionato) return;
    try {
      await updateDoc(doc(db, "utenti", selezionato.id), { nome:form.nome, email:form.email, ruolo:form.ruolo.toLowerCase(), localeTag:form.localeTag });
      setMessaggio("✅ Modifiche salvate.");
      setSelezionato(null);
      carica();
    } catch { setMessaggio("❌ Errore nel salvataggio."); }
  };

  const elimina = async (id) => {

    if (!window.confirm("Eliminare completamente questo utente?")) {
      return;
    }

    try {

      const deleteUserCompletely = httpsCallable(
        functions,
        "deleteUserCompletely"
      );

      await deleteUserCompletely({
        uid: id
      });

      setMessaggio("✅ Utente eliminato completamente.");

      carica();

    } catch (err) {

      console.error(err);

      setMessaggio("❌ Errore eliminazione.");
    }
  };

  const filtrati = utenti.filter(u => {
    const v = search.trim().toLowerCase();
    return !v || (u.nome||"").toLowerCase().includes(v) || (u.email||"").toLowerCase().includes(v);
  });

  const isOk = messaggio.startsWith("✅");

  return (
    <>
      <Navbar />
      <div style={{ minHeight:"100vh", background:C.bg, fontFamily:F, color:C.text }}>
        <div className="page-with-navbar" style={{ maxWidth:900, margin:"0 auto" }}>

          {/* Header */}
          <div style={{ display:"flex", flexWrap:"wrap", justifyContent:"space-between", alignItems:"flex-end", gap:"1rem", marginBottom:"1.75rem" }}>
            <div>
              <p style={{ margin:"0 0 0.25rem", fontSize:"0.72rem", color:C.sec, fontWeight:500 }}>Amministrazione</p>
              <h1 style={{ margin:0, fontSize:"clamp(1.4rem,3vw,1.9rem)", fontWeight:700, letterSpacing:"-0.5px" }}>
                Gestione Utenti <span style={{ fontSize:"1rem", color:C.sec, fontWeight:400 }}>({filtrati.length})</span>
              </h1>
            </div>
            <div style={{ display:"flex", gap:"0.6rem", flexWrap:"wrap", alignItems:"center" }}>
              <input type="text" value={search} onChange={e=>setSearch(e.target.value)} placeholder="Cerca…"
                style={{ ...inp, width:"auto", minWidth:160, marginBottom:0 }}
                onFocus={e=>e.target.style.borderColor=C.accent+"88"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.09)"} />
              <button onClick={() => navigate("/registrazione-utente")} style={{ padding:"0.62rem 1.1rem", background:C.accent, border:"none", borderRadius:10, color:"#fff", fontSize:"0.82rem", fontWeight:600, cursor:"pointer", fontFamily:F, whiteSpace:"nowrap" }}>
                + Nuovo utente
              </button>
            </div>
          </div>

          {messaggio && (
            <div style={{ padding:"0.7rem 1rem", borderRadius:10, marginBottom:"1rem", fontSize:"0.8rem", fontWeight:600, background:isOk?"rgba(48,209,88,0.1)":"rgba(255,69,58,0.1)", border:`1px solid ${isOk?"rgba(48,209,88,0.25)":"rgba(255,69,58,0.25)"}`, color:isOk?C.green:C.red }}>
              {messaggio.replace("✅ ","").replace("❌ ","")}
            </div>
          )}

          {/* Edit form */}
          {selezionato ? (
            <div style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:20, padding:"1.5rem", marginBottom:"1.25rem" }}>
              <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:"1.25rem" }}>
                <h2 style={{ margin:0, fontSize:"1rem", fontWeight:700 }}>Modifica utente</h2>
                <button onClick={() => setSelezionato(null)} style={{ background:"none", border:"none", color:C.sec, fontSize:"1.2rem", cursor:"pointer" }}>✕</button>
              </div>
              <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:"0 0.75rem" }}>
                {[{l:"Nome",k:"nome",t:"text"},{l:"Email",k:"email",t:"email"},{l:"LocaleTag",k:"localeTag",t:"text"}].map(({l,k,t})=>(
                  <div key={k}>
                    <label style={{ display:"block", marginBottom:"0.3rem", fontSize:"0.7rem", color:C.sec, fontWeight:500 }}>{l}</label>
                    <input style={inp} type={t} value={form[k]} onChange={e=>setForm({...form,[k]:e.target.value})}
                      onFocus={e=>e.target.style.borderColor=C.accent+"88"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.09)"} />
                  </div>
                ))}
                <div>
                  <label style={{ display:"block", marginBottom:"0.3rem", fontSize:"0.7rem", color:C.sec, fontWeight:500 }}>Ruolo</label>
                  <select style={{ ...inp, cursor:"pointer" }} value={form.ruolo} onChange={e=>setForm({...form,ruolo:e.target.value})}
                    onFocus={e=>e.target.style.borderColor=C.accent+"88"} onBlur={e=>e.target.style.borderColor="rgba(255,255,255,0.09)"}>
                    <option value="">Seleziona</option>
                    <option value="admin">Admin</option>
                    <option value="gestore">Gestore</option>
                    <option value="cassa">Cassa</option>
                  </select>
                </div>
              </div>
              <div style={{ display:"flex", gap:"0.6rem" }}>
                <button onClick={salva} style={{ flex:1, padding:"0.72rem", background:C.accent, border:"none", borderRadius:10, color:"#fff", fontSize:"0.85rem", fontWeight:600, cursor:"pointer", fontFamily:F }}>Salva modifiche</button>
                <button onClick={() => setSelezionato(null)} style={{ padding:"0.72rem 1.1rem", background:C.surface, border:`1px solid ${C.border}`, borderRadius:10, color:C.sec, fontSize:"0.85rem", cursor:"pointer", fontFamily:F }}>Annulla</button>
              </div>
            </div>
          ) : null}

          {/* Users list */}
          {filtrati.length === 0 ? (
            <p style={{ color:C.ter, textAlign:"center", padding:"3rem 0" }}>Nessun utente trovato.</p>
          ) : (
            <div style={{ display:"flex", flexDirection:"column", gap:"0.55rem" }}>
              {filtrati.map(u => {
                const roleColor = ROLE_COLORS[u.ruolo] || C.sec;
                return (
                  <div key={u.id} style={{ background:C.surface, border:`1px solid ${C.border}`, borderRadius:16, padding:"0.9rem 1.1rem", display:"flex", flexWrap:"wrap", alignItems:"center", gap:"0.75rem", transition:"background 150ms ease" }}
                    onMouseEnter={e=>e.currentTarget.style.background=C.sh}
                    onMouseLeave={e=>e.currentTarget.style.background=C.surface}>
                    {/* Avatar */}
                    <div style={{ width:38, height:38, borderRadius:"50%", background:roleColor+"22", border:`1px solid ${roleColor}44`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:"1rem", flexShrink:0 }}>
                      {(u.nome||"?")[0].toUpperCase()}
                    </div>
                    <div style={{ flex:1, minWidth:120 }}>
                      <p style={{ margin:"0 0 0.15rem", fontSize:"0.88rem", fontWeight:700, color:C.text }}>{u.nome || "—"}</p>
                      <p style={{ margin:0, fontSize:"0.72rem", color:C.sec }}>{u.email}</p>
                    </div>
                    <div style={{ display:"flex", alignItems:"center", gap:"0.5rem", flexWrap:"wrap" }}>
                      <span style={{ fontSize:"0.65rem", fontWeight:700, padding:"3px 9px", borderRadius:6, background:roleColor+"18", border:`1px solid ${roleColor}33`, color:roleColor }}>
                        {u.ruolo || "—"}
                      </span>
                      {u.localeTag && <span style={{ fontSize:"0.65rem", color:C.ter, background:"rgba(255,255,255,0.05)", padding:"3px 8px", borderRadius:6 }}>{u.localeTag}</span>}
                    </div>
                    <div style={{ display:"flex", gap:"0.45rem" }}>
                      <Btn onClick={() => apriModifica(u)} color={C.accent}>Modifica</Btn>
                      <Btn onClick={() => elimina(u.id)} color={C.red}>Elimina</Btn>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </>
  );
}
